/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cookieRefresh} from '../api'

export const useMutationCookieRefresh = createReactQueryMutationHook('cookieRefresh', cookieRefresh)
